import { useLocation } from 'react-router-dom';
import { HOME_JSON_LD, SEO_ROUTES } from '../config/seo';
import { usePageSeo } from '../hooks/usePageSeo';

export default function RouteSeo() {
  const { pathname } = useLocation();
  const config = SEO_ROUTES[pathname] || SEO_ROUTES.default;
  const jsonLd = pathname === '/' ? HOME_JSON_LD : null;

  usePageSeo({
    title: config.title,
    description: config.description,
    path: config.path ?? pathname,
    index: config.index,
    jsonLd,
  });

  return null;
}
